// Module
var code = "<embed data-ng-attr-src={{$ctrl.src}} type=\"\" height=100% width=100%> <p> <span translate>PREVIEW_MODE.NO_PDF_VIEWER</span> <br/> <a data-ng-attr-href={{$ctrl.src}} translate> PREVIEW_MODE.PDF_DOWNLOAD </a> </p> ";
// Exports
module.exports = code;